import type { GroupDetail } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import type { GroupScope } from '../models';
import { useGetGroupScopeName } from './useGetGroupScopeName';

export const useGetGroupEntityBreadcrumb = ({
  entityScope,
  group,
}: {
  entityScope: GroupScope;
  group: GroupDetail;
}) => {
  const { t } = useTranslation();
  const getGroupScopeName = useGetGroupScopeName();

  return useMemo(
    () => [
      {
        path: routes.organization.index,
        title: t('Organizations'),
      },
      {
        path: routes.group.detail.scope(group.id),
        title: group.name,
      },
      {
        path: routes.group.entities(group.id, entityScope),
        title: t(getGroupScopeName({ entityScope })),
      },
    ],
    [entityScope, getGroupScopeName, group.id, group.name, t],
  );
};
